import React from 'react';
import styled from '@emotion/styled';
import { isNative } from '../../platform';

interface TrialExpiredScreenProps {
  onOpenBilling: () => void;
}

export const TrialExpiredScreen: React.FC<TrialExpiredScreenProps> = ({ onOpenBilling }) => {
  // No billing/trial UI on native apps
  if (isNative()) return null;

  return (
    <Overlay>
      <Content>
        <Logo>Mailander</Logo>
        <Heading>Your trial has expired</Heading>
        <Subtext>Subscribe to continue using Mailander</Subtext>
        <SubscribeButton onClick={onOpenBilling}>Subscribe Now</SubscribeButton>
        <ManageLink onClick={onOpenBilling}>Manage Billing</ManageLink>
      </Content>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 900;
  background: #1a1a1c;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  max-width: 420px;
  padding: 40px;
  text-align: center;
`;

const Logo = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: #e9ecf5;
  margin-bottom: 24px;
  letter-spacing: -0.5px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #e9ecf5;
  margin: 0;
`;

const Subtext = styled.p`
  font-size: 15px;
  color: #8a8f9e;
  margin: 0 0 16px;
  line-height: 1.5;
`;

const SubscribeButton = styled.button`
  background: #5e84ed;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #4a6fd6;
  }
`;

const ManageLink = styled.button`
  background: none;
  border: none;
  color: #5e84ed;
  font-size: 14px;
  cursor: pointer;
  padding: 8px;
  text-decoration: underline;

  &:hover {
    color: #4a6fd6;
  }
`;
